import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '@shared/services/registration.service';
import { RegistrationStep } from '@shared/services/steps.service';

@Component({
    selector: 'registration-nav',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
    activeStep: RegistrationStep = null;
    activeMacroStepIndex = 0;
    numberOfMacroSteps: number;
    // 0 to 1 completion ration of current Step
    absoluteProgress = 1;

    constructor(
        private readonly registrationService: RegistrationService
    ) { }

    ngOnInit() {
        const steps = this.registrationService.getRegistrationFlowSnapshot();
        this.handleStepChange(steps.find(s => s.active));

        this.registrationService.getStepChangeObservable().subscribe(registrationStep => {
            this.handleStepChange(registrationStep);
        });
    }

    handleStepChange(registrationStep: RegistrationStep) {
        this.activeStep = registrationStep;
        const registrationFlow = this.registrationService.getRegistrationFlowSnapshot();
        const stepsInTheFlow = registrationFlow.filter(s => s.isEnabled() && !s.hideFromNavigationBar);
        const macroStepsInTheFlow = stepsInTheFlow.map(s => s.macroStep).filter((value, index, self) => self.indexOf(value) === index);
        this.activeMacroStepIndex = macroStepsInTheFlow.indexOf(this.activeStep.macroStep);
        this.numberOfMacroSteps = macroStepsInTheFlow.length;
        const stepsCompleted = stepsInTheFlow.indexOf(this.activeStep);
        this.absoluteProgress = stepsCompleted / stepsInTheFlow.length;
    }
}
